import {h, Fragment} from "preact"
export default function Select({ value, onChange, className, options }) {
    const selectedLabel = options.find(option => option.value === value)?.label || '';

    return (
        <div className="ns-select-wrapper ns-relative">
            {/* Visually hidden label for screen readers */}
                <label htmlFor="plp-sort-select" className="visually-hidden">
                Sort by: {selectedLabel}
            </label>

            <select
                id="plp-sort-select"
                className={`!border-0 !p-0 !outline-0 !shadow-none !leading-normal ${className}`}
                value={value}
                onChange={onChange}
                aria-label={`Sort by: ${selectedLabel}`}
            >
                {options.map(option => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    )
}